import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Moment from "react-moment";
import "./BookingSeats.css";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import BasicTabs from "./BasicTabs";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import language from "../../../../language";
import moment from "moment";
import {
  NonRegularPackageId,
  SelectDepartTripId,
  SelectPackageId,
  SelectReturnTripId,
  UpdateCurrentTrip,
  UpdateDepartTripId,
  UpdateReturnTripId,
} from "../../../../actions/bookings";

const SelectBtnSection = ({
  allBuses,
  bus,
  trip,
  operator,
  selectedDepartureDate,
  tripType,
  departureTripId,
  departureTripDate,
  returnTripDate,
  oldbooking,
  modifyTrip,
  isPackage,
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    // width: 800,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    maxHeight: "90vh",
    overflow: "auto",
    p: 4,
  };
  const history = useHistory();
  const dispatch = useDispatch();
  const data = useSelector((state) => state?.buses?.requesInfo);
  const userData = useSelector((state) => state?.userReducer?.userData?.user);
  const requestTripType = useSelector(
    (state) => state?.buses?.requesInfo?.tripType
  );
  const departureTripRegularId = useSelector(
    (state) => state?.bookings?.bookingInfo?.departureTripRegularId
  );
  const returnTripId = useSelector(
    (state) => state?.bookings?.bookingInfo?.returnTripId
  );
  const returnTripRegularId = useSelector(
    (state) => state?.bookings?.bookingInfo?.returnTripRegularId
  );
  const [openModal, setOpenModal] = React.useState(false);
  const [openModal2, setOpenModal2] = React.useState(false);
  const handleCloseModal = () => setOpenModal(false);
  const handleCloseModal2 = () => setOpenModal2(false);
  const handleOpenModal2 = () => setOpenModal2(true);
  const [inputselectedSeats, setInputSelectedSeats] = useState(null);
  const [tripId, setTripId] = React.useState(null);

  let departureTime = moment(trip?.departureTime, "HH:mm");
  let arrivalTime = moment(trip?.arrivalTime, "HH:mm");
  if (arrivalTime.isBefore(departureTime)) {
    arrivalTime = arrivalTime.add(1, "days");
  }

  // Calculate the duration in hours (decimal included)
  const duration = moment.duration(arrivalTime.diff(departureTime));
  const hours = Math.floor(duration.asHours()); // Get whole hours
  const minutes = duration.minutes(); // Get remaining minutes

  // Format as "H:mm"
  const formattedDuration = `${hours}:${minutes.toString().padStart(2, "0")}`;

  let languageSelectedEnglish =
    sessionStorage.getItem("language") === "english" ||
    !sessionStorage.getItem("language")
      ? true
      : false;

  const handleOpenModal = (id) => {
    setOpenModal(true);
    setTripId(id); // Store the tripId when modal opens
  };
  useEffect(() => {
    setInputSelectedSeats(data?.totalPassenger);
  }, [data]);
  let dataSenderinput = {
    // busId: allBuses[0]?._id,
    noOfSeats: inputselectedSeats,
    seats: null,
    phone: userData?.phone,
    email: userData?.email,
    price: null,
  };

  const updateTripId = (e) => {
    if (tripType === "Departure") {
      if (e?.type === "regular") {
        dispatch(
          SelectDepartTripId({ tripId: e._id, date: departureTripDate })
        );
      } else {
        dispatch(UpdateDepartTripId(e));
        dispatch(UpdateCurrentTrip(trip));
      }
    } else {
      if (e?.type === "regular") {
        dispatch(SelectReturnTripId({ tripId: e._id, date: returnTripDate }));
      } else {
        dispatch(UpdateReturnTripId(e));
        dispatch(UpdateCurrentTrip(trip));
      }
    }
  };

  const setPackageId = (e, price, packageAccom) => {
    if (e?.type === "regular") {
      dispatch(
        SelectPackageId({
          packageId: e._id,
          date: departureTripDate,
          packageAccom,
        })
      );
    } else {
      console.log(e, "updateId");
      dispatch(NonRegularPackageId(e, packageAccom));
      dispatch(UpdateCurrentTrip(trip));
    }

    history.push({
      pathname: "/client/passenger-detail",
      state: dataSenderinput,
    });
  };

  return (
    <>
      <div className="plicyBtnsSections">
        <button
          className="ticketPolicyBtnDisplay"
          onClick={(e) => handleOpenModal2(e)}
        >
          Ticket Policy
        </button>
        <button
          className=" ticketPolicyBtnDisplay"
          onClick={() => handleOpenModal(trip)}
        >
          {modifyTrip &&
          trip._id ===
            (tripType === "Return"
              ? oldbooking?.tripDetails[1]?.trip?._id
              : oldbooking?.tripDetails[0]?.trip?._id)
            ? languageSelectedEnglish
              ? `View and Reselect Seat`
              : language.viewAndSelectSeat
            : languageSelectedEnglish
            ? `View and select Seat`
            : language.viewAndSelectSeat}
        </button>
        {isPackage && trip?.priceOptions[0].active && (
          <button
            className="ticketPolicyBtnDisplay maroonBtn"
            onClick={(e) =>
              setPackageId(trip, trip?.priceOptions[0].priceWith, "with")
            }
          >
            <span className="mainPackPrice">
              {" "}
              SAR {trip?.priceOptions[0].priceWith}{" "}
            </span>{" "}
            <br /> with accommodation
          </button>
        )}
        {isPackage && trip?.priceOptions[1].active && (
          <button
            className="ticketPolicyBtnDisplay maroonBtn"
            onClick={(e) =>
              setPackageId(trip, trip?.priceOptions[1].priceWithout, "without")
            }
          >
            <span className="mainPackPrice">
              SAR{trip?.priceOptions[1].priceWithout}
            </span>{" "}
            <br /> without accommodation
          </button>
        )}
        {isPackage && trip?.priceOptions[2].active && (
          <button
            className="ticketPolicyBtnDisplay maroonBtn"
            onClick={(e) =>
              setPackageId(
                trip,
                trip?.priceOptions[2].priceWithAcomFood,
                "food"
              )
            }
          >
            <span className="mainPackPrice">
              SAR{trip?.priceOptions[2].priceWithAcomFood}
            </span>{" "}
            <br /> with food & accommodation
          </button>
        )}
        {isPackage && trip?.priceOptions[3].active && (
          <button
            className="ticketPolicyBtnDisplay maroonBtn"
            onClick={(e) =>
              setPackageId(
                trip,
                trip?.priceOptions[3].priceWithVisaAcomFood,
                "Visa"
              )
            }
          >
            <span className="mainPackPrice">
              SAR{trip?.priceOptions[3].priceWithVisaAcomFood}
            </span>{" "}
            <br /> with Visa,food & accommodation
          </button>
        )}
        {requestTripType === "Round Trip" && (
          <button
            className={`ml-[12px]  ${
              trip?._id === departureTripId ||
              trip?._id === departureTripRegularId ||
              trip?._id === returnTripRegularId ||
              trip?._id === returnTripId
                ? "selectedBtn"
                : "ticketPolicyBtnDisplay"
            }`}
            onClick={() => updateTripId(trip)}
          >
            {trip?._id === departureTripId ||
            trip?._id === departureTripRegularId ||
            trip?._id === returnTripRegularId ||
            trip?._id === returnTripId
              ? "Selected"
              : "Select"}
          </button>
        )}
        {requestTripType !== "Round Trip" && !isPackage && (
          <Link
            to={{
              pathname: modifyTrip
                ? "/client/checkout"
                : "/client/passenger-detail",
              state: dataSenderinput,
            }}
            onClick={() => updateTripId(trip)}
          >
            <button className="ticketPolicyBtnDisplay">
              Proceed to Booking
            </button>
          </Link>
        )}
      </div>
      <div>
        <Modal
          open={openModal}
          onClose={(e) => handleCloseModal(e)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          style={{ borderRadius: "10px" }}
        >
          <Grid container justifyContent="center">
            <Grid
              item
              xl={6}
              lg={7}
              md={10}
              sm={11}
              xs={12}
              sx={style}
              style={{
                borderRadius: "15px",
                border: "thin solid #fff",
              }}
              className="seatSelectMOdal"
            >
              <Grid container className="ModalContainer">
                <Grid
                  item
                  xs={12}
                  flexDirection="row"
                  className="ModalWrapper"
                  justifyContent="space-between"
                  display="flex"
                >
                  <h5 className="heading">
                    {languageSelectedEnglish
                      ? "Bus Booking Details"
                      : language.busBookingDetails}
                  </h5>
                  <CloseIcon
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleCloseModal(e)}
                  />
                </Grid>
                <Grid
                  container
                  className="tableContainer"
                  flexDirection="row"
                  justifyContent="space-between"
                >
                  <Grid
                    item
                    xl
                    lg
                    md
                    sm={12}
                    xs={12}
                    className="tableCol"
                    style={{ margin: "10px 0" }}
                  >
                    <p className="heading">{operator?.companyname}</p>
                  </Grid>
                  <Grid
                    item
                    xl
                    lg
                    md
                    sm={12}
                    xs={12}
                    className="tableCol"
                    style={{ margin: "10px 0" }}
                  >
                    <p className="heading">
                      {" "}
                      <span>{trip.departureTime}</span>
                    </p>
                  </Grid>
                  <Grid
                    item
                    xl
                    lg
                    md
                    sm={12}
                    xs={12}
                    className="tableCol"
                    style={{ margin: "10px 0" }}
                  >
                    <p className="heading">
                      {formattedDuration}
                      Hours
                    </p>
                  </Grid>
                  <Grid
                    item
                    xl
                    lg
                    md
                    sm={12}
                    xs={12}
                    className="tableCol"
                    style={{ margin: "10px 0" }}
                  >
                    <p className="heading">
                      {" "}
                      <span>{trip.arrivalTime}</span>
                    </p>
                  </Grid>
                </Grid>
                <Grid item xs={12} className="TabContainer">
                  <BasicTabs
                    key={tripId}
                    availableSeats={trip?.totalSeats}
                    busId={bus?._id}
                    occupiedSeats={trip?.occupiedSeats}
                    busPrice={trip?.price}
                    packagePrice={trip?.priceWithout}
                    trip={trip}
                    seatSelection={bus?.seatSelection}
                    openModal={openModal}
                    handleCloseModal={(e) => handleCloseModal(e)}
                    tripId={tripId}
                    tripType={tripType}
                    setOpenModal={setOpenModal}
                    departureTripDate={departureTripDate}
                    returnTripDate={returnTripDate}
                    oldbooking={oldbooking}
                    modifyTrip={modifyTrip}
                    isPackage={isPackage}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Modal>
      </div>
      <div>
        <Modal
          open={openModal2}
          onClose={(e) => handleCloseModal2(e)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "10px",
              maxWidth: "700px",
              position: "relative",
            }}
          >
            <h5 className="refundHeading">
              {languageSelectedEnglish
                ? "Ticket Policy"
                : language.busBookingDetails}
            </h5>
            <CloseIcon
              style={{
                cursor: "pointer",
                position: "absolute",
                top: "14px",
                right: "14px",
              }}
              onClick={(e) => handleCloseModal2(e)}
            />
            <div className="policyDetailText">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
              electronic typesetting, remaining essentially unchanged. It was
              popularised in the 1960s with the release of Letraset sheets
              containing Lorem Ipsum passages, and more recently with desktop
              publishing software like Aldus PageMaker including versions of
              Lorem Ipsum.
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default SelectBtnSection;
